import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';

import { ToastrModule } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPaginationModule } from 'ngx-pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './pages/login/login.component';
import { SignupComponent } from './pages/signup/signup.component';
import { SearchComponent } from './pages/search/search.component';
import { ResetComponent } from './pages/reset/reset.component';
import { ForgotComponent } from './pages/forgot/forgot.component';
import { ConnectWalletComponent } from './pages/connect-wallet/connect-wallet.component';
import { CreateWalletComponent } from './pages/create-wallet/create-wallet.component';
import { TransactiondetailsComponent } from './pages/transactiondetails/transactiondetails.component';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { ComponentsModule } from './components/components.module';
import { TokenTrackerComponent } from './pages/token-tracker/token-tracker.component';
import { ProposalsComponent } from './pages/proposals/proposals.component';
import { RepresentativesComponent } from './pages/representatives/representatives.component';
import { VotesComponent } from './pages/votes/votes.component';
import { CommitteeComponent } from './pages/committee/committee.component';
import { MyproposalComponent } from './pages/myproposal/myproposal.component';
import { TermsComponent } from './pages/terms/terms.component';
import { SrprofileComponent } from './pages/srprofile/srprofile.component';
import { HomeModule } from './pages/home/home.module';
import { InnerHeaderModule } from './inner-header/inner-header.module';
import { InnerFooterModule } from './inner-footer/inner-footer.module';
import { BasicLayoutModule } from './layouts/basic-layout/basic-layout.module';
import { HeaderModule } from './components/header/header.module';
import { FooterModule } from './components/footer/footer.module';
import { ExplorerComponent } from './pages/explorer/explorer.component';
import { SiteunderModule } from './pages/siteunder/siteunder.module';
import { ContractReadComponent } from './pages/contract-read/contract-read.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { GovernanceBodiesComponent } from './pages/governance-bodies/governance-bodies.component';
import { ListValidatorsComponent } from './pages/list-validators/list-validators.component';
import { DateagoPipe } from '../app/pipes/dateago.pipe';
import { TransactionHistoryComponent } from './pages/transaction-history/transaction-history.component';
import { TokenTransfersComponent } from './pages/token-transfers/token-transfers.component';
import { FreezeHistoryComponent } from './pages/freeze-history/freeze-history.component';
import { WithdrawHistoryComponent } from './pages/withdraw-history/withdraw-history.component';
import { DateModule } from 'src/app/date/date.module';
import { ChartsComponent } from '../app/pages/charts/charts.component';
import { TrxPriceComponent } from '../app/pages/trx-price/trx-price.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { SideMenuComponent } from './layouts/side-menu/side-menu.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ExplorerHeaderModule } from './components/explorer-header/explorer-header.module';
import { NgMarqueeModule } from 'ng-marquee';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { NetworkChartsComponent } from './pages/network-charts/network-charts.component';
import { AccountsChartsComponent } from './pages/accounts-charts/accounts-charts.component';
import { TransactionChartsComponent } from './pages/transaction-charts/transaction-charts.component';
import { ContractChartsComponent } from './pages/contract-charts/contract-charts.component';
import { HeaderComponent } from './components/header/header.component';
import { OtpComponent } from './pages/otp/otp.component';
import { ResendMailComponent } from './pages/resend-mail/resend-mail.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { UnfreezeHistoryComponent } from './pages/unfreeze-history/unfreeze-history.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';



export function tokenGetter() {
  return localStorage.getItem("Sastana_Token");
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    SearchComponent,
    ResetComponent,
    ForgotComponent,
    ConnectWalletComponent,
    CreateWalletComponent,
    TransactiondetailsComponent,
    BasicLayoutComponent,
    MainLayoutComponent,
    TokenTrackerComponent,
    ProposalsComponent,
    RepresentativesComponent,
    VotesComponent,
    CommitteeComponent,
    MyproposalComponent,
    TermsComponent,
    SrprofileComponent,
    ExplorerComponent,
    ContractReadComponent,
    GovernanceBodiesComponent,
    ListValidatorsComponent,
    TransactionHistoryComponent,
    TokenTransfersComponent,
    FreezeHistoryComponent,
    WithdrawHistoryComponent,
    ChartsComponent,
    TrxPriceComponent,
    SideMenuComponent,
    NetworkChartsComponent,
    AccountsChartsComponent,
    TransactionChartsComponent,
    ContractChartsComponent,
    OtpComponent,
    ResendMailComponent,
    UnfreezeHistoryComponent,



  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TabsModule.forRoot(),
    HttpClientModule,
    ComponentsModule,
    FormsModule,
    InnerHeaderModule,
    InnerFooterModule,
    BasicLayoutModule,
    HeaderModule,
    SiteunderModule,
    NgxSpinnerModule,
    FooterModule,
    HomeModule,
    ExplorerHeaderModule,
    HttpClientModule,
    NgxPaginationModule,
    DateModule,
    CollapseModule,
    CarouselModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      timeOut: 4000
    }),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    AccordionModule.forRoot(),
    NgMarqueeModule,
    NgApexchartsModule
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  providers: [HeaderComponent],
  bootstrap: [AppComponent],

})
export class AppModule { }






